import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Wraps pages that should only be reachable by an admin user (role=admin
 * OR team_role=admin). If `allowHr` is passed, users with team_role=hr are
 * also permitted — used for HR-managed pages like Documentation, Users
 * and Pending Approvals.
 */
export default function AdminRoute({ children, allowHr = false }) {
  const { user } = useAuth();
  const teamRole = (user?.team_role || "").toLowerCase();
  const isAdmin = user?.role === "admin" || teamRole === "admin";
  const isHr = teamRole === "hr" || (user?.role || "").toLowerCase() === "hr_manager";
  if (isAdmin) return children;
  if (allowHr && isHr) return children;
  return <Navigate to="/dashboard" replace />;
}
